export default {
	computed:{
		isUserReseller() {
			return (
				this.$store.state.home &&
				this.$store.state.home.user &&
				"reseller_settings" in this.$store.state.home.user &&
				this.$store.state.home.user.reseller_settings !== null
			);
		},
		firstUserConfigurableOptionName() {
			if (this.hasSelectedServiceUserConfigurableOptions()) {
				return this.selectedService.onboarding.user_configurable_options[0].name;
			}
			return null;
		}
	},
	methods: {
		hasSelectedServiceLimitReached() {
			return this.selectedService?.instance_count >= this.selectedService?.instance_limit;
		},
		canSelectedServiceChooseTheme() {
			if (this.selectedService?.install_method == "standard" && !this.selectedService?.choose_theme) {
				return false;
			}
			if (this.selectedService?.install_method == "quick" && this.selectedService?.plan_default_theme) {
				return false;
			}
			if (this.selectedService?.install_method == "quick" && this.selectedService?.is_installed_from_template && !this.selectedService?.quick_allow_to_choose_themes) {
				return false;
			}
			if (this.selectedService?.install_method == "super_quick") {
				return false;
			}
			return true;
		},
		canSelectedServiceShareAccess() {
			return this.isUserReseller || this.selectedService?.onboarding?.can_select_reseller_user;
		},
		hasSelectedServiceUserConfigurableOptions() {
			return this.selectedService?.onboarding?.user_configurable_options.length > 0;
		},
		hasSelectedServiceStandardOnboarding() {
			return this.selectedService?.install_method === "standard";
		},
		hasSelectedServiceSuperQuickOnboarding() {
			return this.selectedService?.install_method === "super_quick";
		},
		hasSelectedServiceAskForDomain() {
			if (this.selectedService?.install_method === "standard") {
				return false
			}
			return this.selectedService?.ask_for_domain;
		},
		hasSelectedServiceAskForSiteName() {
			if (this.selectedService?.install_method === "standard") {
				return false
			}
			if (this.selectedService?.install_method === "quick") {
				return true;
			}
			return this.selectedService?.onboarding.super_quick_ask_for_site_name
		},
		isSelectedServiceServerAllowTransferDomain() {
			return this.selectedService?.onboarding.server_allow_domain_transfer;
		},
		canSelectedServiceTransferDomain() {
			return this.selectedService?.onboarding.domain_transfer_enabled;
		},
		hasSelectedServiceInstantVerificationEnabled() {
			return this.selectedService?.onboarding.eager_domain_dns_verification_enabled;
		},
	}
}